module.exports = __webpack_public_path__ + "img/contact-web.982ff235.svg";